<template>
  <t-form label-width="100px">
    <CptData :data="attribute.cptTableData" :cptDataForm="cptDataForm"/>
    <t-form-item label="边框粗细">
      <t-input-number size="small" :min="1" :max="100" v-model="attribute.borderWidth" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="边框圆角">
      <t-input-number size="small" :min="0" :max="100" v-model="attribute.borderRadius" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="内边距">
      <t-input-number size="small" :min="0" :max="100" v-model="attribute.borderGap" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="局部渐变">
      <t-switch :label="['开', '关']" size="small" v-model="attribute.localGradient"/>
    </t-form-item>
    <t-form-item label="线条粗细">
      <t-input-number size="small" :min="0" :max="50" v-model="attribute.lineWidth" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="线条间隔">
      <t-input-number size="small" :min="0" :max="20" v-model="attribute.lineSpace" :decimal-places="0"/>
    </t-form-item>
    <t-form-item label="颜色1">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.colors[0]" enableAlpha/>
    </t-form-item>
    <t-form-item label="颜色2">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.colors[1]" enableAlpha/>
    </t-form-item>
    <t-form-item label="数值颜色">
      <t-color-picker :colorModes="['monochrome']" format="RGBA" size="small" v-model="attribute.textColor" enableAlpha/>
    </t-form-item>
    <t-form-item label="显示百分比">
      <t-switch v-model="attribute.numShow" :label="['显示', '隐藏']" size="small"/>
    </t-form-item>
  </t-form>
</template>

<script>
import CptData from '@/components/element/options/comp/cpt-data'
export default {
  name: "cpt-dataV-percentPond-option",
  components: { CptData },
  props: { 
    attribute: Object,
    cptDataForm:Object,
   }
}
</script>

<style scoped>

</style>
